import { createFileRoute } from "@tanstack/react-router";
import { PropertyDetail } from "@/components/assets/property-detail";
import { assetPropertyQuery, employeeDirectoryQuery, warm } from "@/lib/workspace-queries";

export const Route = createFileRoute("/_workspace/assets/$id")({
  // A head start; the page renders its own skeleton.
  loader: ({ context, params }) => {
    warm(context.queryClient.ensureQueryData(assetPropertyQuery(params.id)));
    warm(context.queryClient.ensureQueryData(employeeDirectoryQuery));
  },
  component: AssetPropertyPage,
});

function AssetPropertyPage() {
  const { id } = Route.useParams();
  return (
    <main className="flex flex-1 flex-col p-4 md:p-6">
      <div className="mx-auto w-full max-w-5xl">
        <PropertyDetail propertyId={id} />
      </div>
    </main>
  );
}
